/* eslint-disable camelcase */
import {
    de,
    deAT,
    enAU,
    enCA,
    enGB,
    enIE,
    enIN,
    enNZ,
    enUS,
    enZA,
    es,
    fr,
    hu,
    it,
    itCH,
    ja,
    ko,
    nl,
    nn,
    pl,
    pt,
    ptBR,
    ru,
    sv,
    th,
    tr,
    zhCN,
    zhHK,
    zhTW,
} from 'date-fns/locale';

export default Object.freeze({
    de_AT: deAT,
    de_CH: de,
    de_DE: de,
    de_LU: de,
    en_AU: enAU,
    en_CA: enCA,
    en_GB: enGB,
    en_IE: enIE,
    en_IN: enIN,
    en_NZ: enNZ,
    en_SG: enGB,
    en_US: enUS,
    en_ZA: enZA,
    es_AR: es,
    es_BO: es,
    es_CL: es,
    es_CO: es,
    es_CR: es,
    es_DO: es,
    es_EC: es,
    es_ES: es,
    es_GT: es,
    es_HN: es,
    es_MX: es,
    es_NI: es,
    es_PA: es,
    es_PE: es,
    es_PR: es,
    es_PY: es,
    es_SV: es,
    es_US: es,
    es_UY: es,
    es_VE: es,
    fr_BE: fr,
    fr_CA: fr,
    fr_CH: fr,
    fr_FR: fr,
    fr_LU: fr,
    hu_HU: hu,
    it_CH: itCH,
    it_IT: it,
    ja_JP: ja,
    ko_KR: ko,
    nl_NL: nl,
    no_NO: nn,
    pl_PL: pl,
    pt_BR: ptBR,
    pt_PT: pt,
    ru_RU: ru,
    sv_SE: sv,
    th_TH: th,
    tr_TR: tr,
    zh_CN: zhCN,
    zh_HK: zhHK,
    zh_MO: zhTW,
    zh_SG: zhCN,
    zh_TW: zhTW,
});
